import React, { useState } from 'react'
import styled from 'styled-components'
import { CButton } from 'app/components/Common'
import { COLORS } from 'app/constants'
import EventUpdateModal from './EventUpdateModal'

const Wrapper = styled.div`
  display: flex;
  align-items: center;
`

const EventUpdate = ({ item }) => {
	const [showModal, setShowModal] = useState(false)

	return (
		<Wrapper>
			<CButton
				title="수정"
				style={{
					background: 'linear-gradient(135deg, #7d8dff 0%, #9c6eff 100%)',
					color: COLORS.white,
					padding: '8px 18px',
					borderRadius: 999,
					fontWeight: 600,
					letterSpacing: 0.4,
				}}
				backgroundHover="linear-gradient(135deg, #8a99ff 0%, #b384ff 100%)"
				onClick={() => setShowModal(true)}
			/>
			<EventUpdateModal
				item={item}
				showModal={showModal}
				setShowModal={setShowModal}
			/>
		</Wrapper>
	)
}

export default EventUpdate
